export const isEmpty = (value: string) => value.length === 0;
